export const metersToKilometers = (meters: number) => {
  return meters / 1000;
};
